
import Vue from "vue";
import AppTotalEditContentWrapper from "./TotalEditContentWrapper.vue";
import AppTotalEditColumn from "./TotalEditColumn.vue";
import { Model } from "@/utils/models/model";
import { ViewTotal } from "@/utils/views/view-total";
import { TotalColumn } from "@/utils/views/total-column";
import { Browse } from "@/models/browse";

export default Vue.extend({
	data(){
		return {
			toEditColumn: null as null | TotalColumn
		};
	},
	props: {
		currentTab: {
			type: Number,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		value: {
			type: Object as ()=>ViewTotal,
			required: true
		},
		browse: {
			type: Object as ()=>Browse,
			required: true
		}
	},
	methods: {
		editColumn(i:number){
			if (this.toEditColumn == this.value.Columns[i]){
				this.toEditColumn = null;
			}else{
				this.toEditColumn = this.value.Columns[i];
			}
		},
		removeColumn(i:number){
			this.value.Columns.splice(i,1);
		},
		addColumn(){
			this.toEditColumn = new TotalColumn();
			this.value.Columns.push(this.toEditColumn);
		}
	},
	mounted(){

	},
	components: {
		AppTotalEditContentWrapper,
		AppTotalEditColumn
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
